var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ClientService from '../../api/ClientService';
import { Loading } from 'element-ui';
import AddSaleMan from "./components/AddSaleMan.vue";
var SaleMandetais = (function (_super) {
    __extends(SaleMandetais, _super);
    function SaleMandetais() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 0;
        _this.rowData = null;
        _this.formData = {};
        return _this;
    }
    SaleMandetais.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 325;
        }, 300);
        this.service = ClientService.getInstance();
        this.getUserList();
        this.customerInfo();
    };
    SaleMandetais.prototype.customerInfo = function () {
        var _this = this;
        var params = {
            supplier_to_business_id: this.rowData.supplier_to_business_id
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                _this.formData = res.data.data ? res.data.data : {};
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    SaleMandetais.prototype.getUserList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var param = { shop_id: 0, business_id: 0 };
        if (this.isOpenApAccountTypeBusiness) {
            param.business_id = this.rowData.business_id;
        }
        else {
            param.shop_id = this.rowData.shop_id;
        }
        this.service.getSaleUser(param).then(function (res) {
            loadingInstance.close();
            var AllDate = Array.isArray(res.data.data) ? res.data.data : [];
            AllDate.forEach(function (item) {
                item.is_admin = item.is_admin == '1' ? '管理员' : '子账号';
            });
            _this.total = res.data.total;
            _this.listData = AllDate;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    SaleMandetais.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    SaleMandetais.prototype.pageChange = function (pager) {
        this.getUserList(pager);
    };
    SaleMandetais.prototype.getSelectIds = function () {
        var account_ids = this.selectRows.map(function (item) { return item.account_id; });
        return account_ids.join(',');
    };
    SaleMandetais.prototype.unbandSaleMan = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择用户进行解绑！');
            return true;
        }
        console.log(this.selectRows);
        this.$confirm('确定后会将业务员与门店进行解绑，确定解绑吗？', '解绑用户').then(function (res) {
            var params = {
                shop_ids: _this.rowData.shop_id,
                account_ids: _this.getSelectIds(),
            };
            _this.service.unbindUser(params).then(function (res) {
                console.log(res.data);
                _this.$message.success(res.data.msg || '操作成功');
                _this.getUserList();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    SaleMandetais.prototype.bindUser = function (row) {
        var _this = this;
        var dialog = this.$dialog(AddSaleMan, {
            data: {
                shopId: this.rowData.shop_id
            }
        }, {
            title: "选择用户",
            width: 700,
            height: 500
        });
        dialog.instance.$on("save:ok", function (res) {
            console.log(res.data);
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                shop_ids: res.shopId,
                account_ids: res.data.toString()
            };
            console.log(params);
            _this.service.bindStore(params).then(function (res) {
                console.log(res.data);
                loadingInstance.close();
                _this.getUserList();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
        });
    };
    SaleMandetais = __decorate([
        Component({})
    ], SaleMandetais);
    return SaleMandetais;
}(Vue));
export default SaleMandetais;
